export default "__VITE_ASSET__B8tJ4bBF__"